import React from "react";
import GenericCRUD from "@/components/common/GenericCRUD";

const config = {
  resource: "blog",
  singular: "article",
  title: "Blog",
  subtitle: "Articles, drafts and scheduled posts.",
  titleKey: "title",
  statusFilter: ["published", "draft"],
  columns: [
    { key: "title", label: "Title", render: (r) => (
      <div className="flex items-center gap-3">
        {r.featured_image ? (
          <img src={r.featured_image} alt="" className="w-10 h-10 rounded object-cover" />
        ) : (
          <div className="w-10 h-10 rounded bg-white/10 flex items-center justify-center text-white/30 text-xs">No img</div>
        )}
        <span className="text-white font-medium">{r.title}</span>
      </div>
    )},
    { key: "author", label: "Author" },
    { key: "category", label: "Category" },
    { key: "reading_time", label: "Read Time", className: "w-24", render: (r) => <span className="text-white/60">{r.reading_time || "—"}</span> },
    { key: "status", label: "Status", badge: true, className: "w-32" },
  ],
  fields: [
    { key: "title", label: "Title", type: "text" },
    { key: "slug", label: "Slug", type: "text", hint: "URL-friendly identifier (auto-generated if empty)" },
    { key: "featured_image", label: "Featured Image", type: "image", folder: "blog", hint: "Upload an image or choose from the media library" },
    { key: "author", label: "Author", type: "text", placeholder: "CAS Media" },
    { key: "category", label: "Category", type: "text", placeholder: "Brand Strategy, Web Development…" },
    { key: "excerpt", label: "Excerpt", type: "textarea", hint: "Short summary shown on blog cards (auto-generated from content if empty)" },
    { key: "tags", label: "Tags", type: "tags" },
    { key: "content", label: "Content (Rich Text)", type: "richtext", placeholder: "Write your article… You can insert images inline using the toolbar." },
    { key: "sections", label: "Content Sections", type: "sections", hint: "Add multiple sections with titles, text, and images for interactive blog layout" },
    { key: "gallery", label: "Image Gallery", type: "gallery", folder: "blog", hint: "Upload multiple images for the blog gallery" },
    { key: "reading_time", label: "Reading Time", type: "text", hint: "e.g. 5 min read (auto-calculated if empty)" },
    { key: "published_at", label: "Publish Date", type: "text", hint: "ISO date or human-readable (e.g. 2026-08-19)" },
    { key: "status", label: "Status", type: "select", options: [
      { label: "Draft", value: "draft" }, { label: "Published", value: "published" }, { label: "Scheduled", value: "scheduled" },
    ]},
    { key: "seo.meta_title", label: "SEO Title", type: "text", hint: "Override page title for search engines" },
    { key: "seo.meta_description", label: "SEO Description", type: "textarea", hint: "Meta description for search engines" },
  ],
  defaultValues: { status: "draft", tags: [], views: 0, comments: [], seo: {}, excerpt: "", featured_image: null, reading_time: "", published_at: "", gallery: [], sections: [] },
};

export default function Blog() { return <GenericCRUD config={config} />; }
